/* eslint-disable @typescript-eslint/no-unused-vars */
import { Divider, Typography } from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import LocalHotelIcon from '@material-ui/icons/LocalHotel'
import React from 'react'

import { getTranslate } from '../../../../localization'
import { RoomPriceDetails } from '../../../../types/bookingDetails'
import { ChargePerDay, DetailedRoomStays } from '../../../../types/cart'
import { Currency } from '../../../../types/currency'
import DiscountDetails from './DiscountDetails'
import PerDayChargeRow from './PerDayChargeRow'
import PerRoomStayChargeRow from './PerRoomStayChargeRow'
import { useStyles } from './styles/index.styles'

type RoomStayPriceDetailsProps = {
  roomsPriceDetails: RoomPriceDetails[]
  curruncy: Currency
}

const RoomStayPriceDetails: React.FC<RoomStayPriceDetailsProps> = ({
  roomsPriceDetails,
  curruncy
}: RoomStayPriceDetailsProps) => {
  const classes = useStyles()
  return (
    <div className={classes.itemContainer}>
      {roomsPriceDetails &&
        roomsPriceDetails.map((d, i) => (
          <div key={i} className={classes.roomContainer}>
            <div className={classes.roomHeader}>
              <Typography variant="h5" className={classes.blackText}>
                {`${getTranslate('Room Stay')} ${i + 1}`}
              </Typography>
              <Typography variant="h6" className={classes.blackText}>
                {`${d.roomTypeName} (${d.ratePlanCode})`}
              </Typography>
            </div>
            {d.chargePerDays.length > 0 && (
              <>
                <Typography variant="h5" className={classes.verticalAlign}>
                  <LocalHotelIcon className={classes.icon} />
                  {getTranslate('Per-Day Charge')}
                </Typography>
                <div className={classes.table}>
                  <div className={classes.tableHeader}>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Date')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Item')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Unit')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Qty')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Discount')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Rate')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Total')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Remarks')}
                    </Typography>
                  </div>
                  {d.chargePerDays.map((chp, index) => (
                    <PerDayChargeRow
                      chargePerDay={chp}
                      key={index}
                      curruncy={curruncy}
                    />
                  ))}
                  <PerDayChargeRow
                    isTotal
                    total={d.totalChargePerDay}
                    curruncy={curruncy}
                  />
                </div>
              </>
            )}
            {d.chargePerRoomStay.length > 0 && (
              <>
                <Typography variant="h5" className={classes.verticalAlign}>
                  <AddCircleIcon className={classes.icon} />
                  {getTranslate('Per-RoomStay Charge')}
                </Typography>
                <div className={classes.table}>
                  <div className={classes.tableHeaderForRoomStay}>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Item')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Unit')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Qty')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Discount')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Rate')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Total')}
                    </Typography>
                    <Typography variant="h5" className={classes.cell}>
                      {getTranslate('Remarks')}
                    </Typography>
                  </div>
                  {d.chargePerRoomStay.map((chps, idx) => (
                    <PerRoomStayChargeRow
                      key={idx}
                      chargePerRoomStay={chps}
                      curruncy={curruncy}
                    />
                  ))}
                  <PerRoomStayChargeRow
                    isTotal
                    total={d.totalChargePerRoomStay}
                    curruncy={curruncy}
                  />
                </div>
              </>
            )}

            {/* <DiscountDetails /> */}
            {/* <Divider /> */}
          </div>
        ))}
    </div>
  )
}

export default RoomStayPriceDetails
